<template>
  <el-table border fit highlight-current-row class="customer-table" :data="data" size="small">
    <el-table-column label="ID" prop="id"></el-table-column>
    <el-table-column label="型号" prop="xhname"></el-table-column>
    <el-table-column label="品牌" prop="source"></el-table-column>
    <el-table-column label="数量" prop="num"></el-table-column>
    <el-table-column label="单价" prop="price"></el-table-column>
    <el-table-column label="总价" prop="zprice"></el-table-column>
  </el-table>
</template>
<script>
import {defineComponent} from '@vue/composition-api'
export default defineComponent({
  components: {},
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  setup() {

  }
})
</script>
<style lang="scss" scoped>
.customer-table {
  width: 96%;
  margin: auto;
}
</style>
